export default "__VITE_ASSET__BYSfCH_B__"